export default __webpack_public_path__ + "static/media/almendra-bold-webfont.6a4cc720.ttf";